import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconLayersSingle12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconLayersSingle12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="m10.321 6-4.32-2.52L1.681 6l4.32 2.52zM6.505 2.615a1 1 0 0 0-1.008 0L.29 5.655a.4.4 0 0 0 0 .69l5.208 3.04a1 1 0 0 0 1.008 0l5.208-3.04a.4.4 0 0 0 0-.69z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconLayersSingle12);
